export default "__VITE_ASSET__CjjP0Rdc__"